import { utcFriday, utcMonth, utcYear } from 'd3-time';

/**
 * Configures the x axis with a Date object formatter and a number of ticks, based on a fitting interval.
 *
 * @memberof Axes
 *
 * @param {string} period day, week, month or year
 * @param {boolean} isSmallScreen Is this a small screen?
 * @param {number} numberOfDataPoints The number of datapoints in the longest trend line
 *
 * @returns {Object} An object with a timeformatter and ticks.
 */

interface IProps {
  period: any;
  isSmallScreen: boolean;
  numberOfDataPoints: any;
}

const getTimeAxisConfiguration = function ({
  period,
  isSmallScreen,
  numberOfDataPoints,
}: IProps): any {
  // the number of data points divided by n gives you n ticks,
  // because you get a tick every (numberOfDataPoints / n)
  // to increase/decrease the amount of ticks, simply update n.
  const nTicks = isSmallScreen
    ? Math.round(numberOfDataPoints / 2)
    : Math.round(numberOfDataPoints / 6);

  const configurations = {
    day: utcFriday,
    week: nTicks === 0 ? utcFriday : utcFriday.every(nTicks), // added utcFriday for Custom Date range
    month: utcMonth.every(nTicks),
    year: utcYear,
  };

  return (configurations as any)[period];
};

export default getTimeAxisConfiguration;
